import { BaseApi } from './base.api.js';

export class PersonalDataInventoryApi extends BaseApi {
    constructor(client) {
        super(client, '/personal-data-inventory');
    }

    async getPartyTemplate(params = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/party-template`, { params });
            return response.data;
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch party template');
        }
    }

    async getParty(id) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/party`);
            return response.data;
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch party instance');
        }
    }

    async syncParty(id, body) {
        try {
            const response = await this.client.put(`${this.basePath}/${id}/party`, body);
            return response.data;
        } catch (error) {
            throw this._handleError(error, 'Failed to sync party');
        }
    }
}
